import Vue from "vue";

import Message from "./message";
import User from "./user";
import Permissions from "./permissions";
import DataLayer from "./dataLayer";
import Config from "./config";

Vue.use(Message);
Vue.use(User);
Vue.use(Permissions);
Vue.use(DataLayer);
Vue.use(Config);
